import React, { useState, useRef, useEffect } from "react";
import { useDispatch } from "react-redux";
import momentTz from "moment-timezone";
import { useNavigate } from "react-router";
import "./AddEmojiModal.css";
import toast from "react-hot-toast";
import { createTariff, createTariffVersion } from "../../store/tariffesSlice";
import CloseButton from "../CloseButton/CloseButton";
import { ClickAwayListener, Switch } from "@mui/material";
import EmojiPicker from "emoji-picker-react";
import { createReaction, fetchReactions } from "../../store/usersSlice";

const AddEmojiModal = ({ onClose = () => {}, onSubmit = () => {} }) => {
  const [activeTab, setActiveTab] = useState("project");
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [emojiName, setEmojiName] = useState("");
  const [emojiCode, setEmojiCode] = useState("");
  const [chosenEmoji, setChosenEmoji] = useState("😃");
  const [emojiPickerOpened, setEmojiPickerOpened] = useState(false);
  const emojiRef = useRef();

  const modalRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        modalRef.current &&
        !modalRef.current.contains(event.target) &&
        !isLoading
      ) {
        onClose();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [onClose]);

  // Add keyframes for spinner animation
  const spinnerStyle = document.createElement("style");
  spinnerStyle.innerHTML = `
    @keyframes spin {
      0% { transform: rotate(0deg); }
      100% { transform: rotate(360deg); }
    }
  `;
  document.head.appendChild(spinnerStyle);

  const handleCreateReaction = () => {
    const data = {
      name: emojiName,
      code: emojiCode,
      emoji: chosenEmoji,
    };

    dispatch(createReaction(data)).then((res) => {
      setIsLoading(false);
      if (!res.error) {
        onSubmit();
        onClose();
      } else {
      }
    });
  };

  return (
    <div style={modalStyles.overlay}>
      <div style={modalStyles.modal} ref={modalRef}>
        <CloseButton onClose={onClose} />
        <h1 style={modalStyles.title}>Добавить реакцию</h1>
        <textarea
          readOnly={isLoading}
          value={emojiName}
          style={{
            ...modalStyles.input,
            lineHeight: "20px",
            display: "-webkit-box",
            WebkitLineClamp: "2",
            WebkitBoxOrient: "vertical",
            overflow: "hidden",
            "::placeholder": {
              color: "#4a4f5c",
            },
          }}
          placeholder={"Название"}
          onChange={(e) => setEmojiName(e.target.value)}
        />
        <textarea
          style={{
            ...modalStyles.input,
            lineHeight: "20px",
            display: "-webkit-box",
            WebkitLineClamp: "2",
            WebkitBoxOrient: "vertical",
            overflow: "hidden",
            "::placeholder": {
              color: "#4a4f5c",
            },
          }}
          readOnly={isLoading}
          placeholder="Код"
          value={emojiCode}
          onChange={(e) => setEmojiCode(e.target.value)}
        />
        <div style={{ display: "flex", flexDirection: "row" }}>
          <span style={{ color: "white" }}>Эмодзи: </span>
          <ClickAwayListener
            onClickAway={(e) => {
              if (!emojiPickerOpened) return;
              const isInside =
                (e.target.className &&
                  e.target.className.includes("epr-btn")) ||
                e.target.className.includes("epr-emoji");
              if (!isInside) {
                setEmojiPickerOpened(false);
              }
            }}
          >
            <div
              style={{ cursor: "pointer", marginLeft: 5 }}
              onClick={() => setEmojiPickerOpened(!emojiPickerOpened)}
            >
              {chosenEmoji}
            </div>
          </ClickAwayListener>
          .{" "}
          <EmojiPicker
            searchDisabled={true}
            onEmojiClick={(emoji) => {
              console.log(emoji);
              setEmojiPickerOpened(false);
              setChosenEmoji(emoji.emoji);
              setEmojiName(emoji.names[0]);
              setEmojiCode(emoji.names[0]);
            }}
            categories={[]}
            previewConfig={{
              showPreview: false,
            }}
            style={{
              position: "absolute",
              bottom: 120,
              zIndex: 10000,
              width: "90%",
              scrollbarWidth: "none" /* Firefox */,
              msOverflowStyle: "none" /* IE and Edge */,
              "&::-webkit-scrollbar": {
                /* Chrome, Safari and Opera */ display: "none",
              },
            }}
            theme="dark"
            ref={emojiRef}
            open={emojiPickerOpened}
          />
        </div>
        <button
          onClick={() => {
            if (!isLoading) {
              setIsLoading(true);
              handleCreateReaction();
            }
          }}
          disabled={isLoading}
          style={
            isLoading
              ? modalStyles.submitButtonDisabled
              : modalStyles.submitButton
          }
        >
          {isLoading ? <span>Загрузка...</span> : "Создать"}
        </button>
      </div>
    </div>
  );
};

const modalStyles = {
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(0, 0, 0, 0.75)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 101,
  },
  modal: {
    width: "410px",
    backgroundColor: "#1f242e",
    borderRadius: "16px",
    // minHeight: "50%",
    padding: "32px",
    position: "relative",
    overflow: "auto",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    scrollbarWidth: "none" /* Firefox */,
    msOverflowStyle: "none" /* IE and Edge */,
    "&::-webkit-scrollbar": {
      /* Chrome, Safari and Opera */ display: "none",
    },
  },
  contentContainer: {
    width: "100%",
    height: "500px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    marginBottom: "32px",
  },
  title: {
    color: "#c1c4cb",
    fontSize: "24px",
    fontWeight: 600,
    fontFamily: "NT Somic",
    marginBottom: "16px",
    textAlign: "center",
  },
  tabContainer: {
    display: "flex",
    gap: "4px",
    marginBottom: "24px",
    justifyContent: "center",
    width: "400px",
  },
  tab: {
    padding: "8px 24px",
    borderRadius: "80px",
    border: "1px solid #333b4b",
    backgroundColor: "#1f242e",
    color: "#717b8e",
    fontSize: "16px",
    fontWeight: 500,
    cursor: "pointer",
    flex: 1,
    //maxWidth: "130px",
    whiteSpace: "nowrap",
    overflow: "visible",
  },
  activeTab: {
    backgroundColor: "#333b4b",
    color: "#e8f2ff",
  },
  input: {
    width: "400px",
    padding: "16px",
    paddingTop: "7px",
    fontFamily: "NT Somic",
    backgroundColor: "transparent",
    border: "1px solid #333b4b",
    borderRadius: "8px",
    color: "#717b8e",
    fontSize: "14px",
    fontWeight: 500,
    marginBottom: "8px",
    resize: "none",
    height: "36px",
    minHeight: "36px",
    maxHeight: "36px",
    lineHeight: "1.5",
    boxSizing: "border-box",
    overflowY: "auto",
  },
  lilInput: {
    width: "130px",
    padding: "16px",
    paddingTop: "4px",
    paddingBottom: "4px",
    fontFamily: "NT Somic",
    backgroundColor: "transparent",
    border: "1px solid #333b4b",
    borderRadius: "8px",
    color: "#717b8e",
    fontSize: "16px",
    fontWeight: 500,
    marginBottom: "8px",
    resize: "none",
    height: "32px",
    minHeight: "32px",
    maxHeight: "32px",
    lineHeight: "1.5",
    boxSizing: "border-box",
    overflowY: "auto",
  },
  textarea: {
    width: "400px",
    height: "100px",
    padding: "16px",
    fontFamily: "NT Somic",
    backgroundColor: "transparent",
    border: "1px solid #333b4b",
    borderRadius: "8px",
    color: "#717b8e",
    fontSize: "16px",
    fontWeight: 500,
    marginBottom: "8px",
    resize: "none",
    boxSizing: "border-box",
  },
  uploadArea: {
    width: "400px",
    height: "70px",
    border: "1px dashed #333b4b",
    borderRadius: "8px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    marginBottom: "8px",
    boxSizing: "border-box",
  },
  uploadIcon: {
    width: "32px",
    height: "32px",
    marginBottom: "8px",
  },
  uploadText: {
    color: "#c1c4cb",
    fontSize: "16px",
    fontWeight: 500,
  },
  uploadLimit: {
    color: "#717b8e",
    fontSize: "14px",
    fontWeight: 500,
  },
  submitButton: {
    padding: "16px 32px",
    backgroundColor: "#e8f2ff",
    borderRadius: "80px",
    border: "none",
    color: "#1f242e",
    fontSize: "16px",
    fontWeight: 500,
    cursor: "pointer",
    alignSelf: "center",
    ":hover": {
      opacity: 0.9,
    },
    ":disabled": {
      opacity: 0.5,
      cursor: "default",
    },
    marginTop: "32px",
  },
  submitButtonDisabled: {
    padding: "16px 32px",
    backgroundColor: "#e8f2ff",
    borderRadius: "80px",
    border: "none",
    color: "#1f242e",
    fontSize: "16px",
    fontWeight: 500,
    cursor: "pointer",
    alignSelf: "center",
    opacity: 0.5,
    cursor: "default",
    marginTop: "32px",
  },
  versionUploadArea: {
    width: "400px",
    height: "144px",
    border: "1px dashed #333b4b",
    borderRadius: "8px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    marginBottom: "16px",
    boxSizing: "border-box",
  },
  versionUploadIcon: {
    width: "32px",
    height: "32px",
    marginBottom: "16px",
  },
  versionUploadText: {
    color: "#c1c4cb",
    fontSize: "16px",
    fontWeight: 500,
    marginBottom: "8px",
    textAlign: "center",
  },
  versionUploadSubtext: {
    color: "#717b8e",
    fontSize: "14px",
    fontWeight: 500,
    textAlign: "center",
    maxWidth: "400px",
  },
  versionLabel: {
    color: "#c1c4cb",
    fontSize: "16px",
    fontWeight: 500,
    marginTop: "8px",
  },
  loadingSpinner: {
    width: "32px",
    height: "32px",
    border: "3px solid #333b4b",
    borderTop: "3px solid #e8f2ff",
    borderRadius: "50%",
    animation: "spin 1s linear infinite",
    marginBottom: "16px",
  },
  uploadProgress: {
    color: "#717b8e",
    fontSize: "14px",
    fontWeight: 500,
    marginTop: "8px",
  },
  versionThumbnail: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
    borderRadius: "8px",
  },
};

export default AddEmojiModal;
